export interface PortfolioItem {
  id: string;
  title: string;
  location: string;
  image: string;
}

export const PORTFOLIO_ITEMS: PortfolioItem[] = [
  {
    id: "loyo",
    title: "Бистро и винный бар «Loyo»",
    location: "Астана",
    image: "/assets/portfolio/loyo-2.webp",
  },
  {
    id: "paradox",
    title: "Бар-караоке «Paradox»",
    location: "Астана",
    image: "/assets/portfolio/paradox.webp",
  },
  {
    id: "take-eat-easy",
    title: "Ресторан «Take Eat Easy»",
    location: "Астана",
    image: "/assets/portfolio/take-eat-easy.webp",
  },
  {
    id: "bizou",
    title: "Гастролавка, бистро, винный ресторан «Bizou»",
    location: "Астана",
    image: "/assets/portfolio/bizou.webp",
  },
  {
    id: "goodday",
    title: "Кафе «Good Day»",
    location: "Астана",
    image: "/assets/portfolio/goodday.webp",
  },
];
